module.exports = __webpack_public_path__ + "media/images/spain_flag-cf5323dbb6f9c728d6e9994df1c97fac.jpg";